import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type SubmitLossReportPayload = {
	[key: string]: any;
};

const submitReport = async (report: SubmitLossReportPayload): Promise<any> => {
	const response = await apiDal.post("/lossreport/new", report);
	return response.data;
};

export const useSubmitLossReport = () => {
	return useMutation({
		mutationFn: submitReport,
	});
};
